// Google Analytics 4 (gtag.js) setup.
//
// The GA4 measurement ID is public (it appears in page source on every site
// that loads gtag), so the production ID is a safe in-repo default — same
// pattern as the HubSpot portal/form IDs in leads.js. Override per-environment
// with REACT_APP_GA_MEASUREMENT_ID, or set it to "" to disable analytics
// entirely (e.g. for a staging build).

const MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID !== undefined
    ? process.env.REACT_APP_GA_MEASUREMENT_ID
    : "G-T8SLSSZLSG";

export const isAnalyticsEnabled = Boolean(MEASUREMENT_ID);

// Loads gtag.js and configures GA4. Safe to call once on app start; repeated
// calls are no-ops.
export function initAnalytics() {
  if (!isAnalyticsEnabled || typeof window === "undefined") return;
  if (window.__gaInitialized) return;
  window.__gaInitialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID);
}

// Fire a custom event (e.g. trackEvent("contact_open", { source: "hero" })).
// No-op when analytics is disabled, so call sites don't need to guard.
export function trackEvent(name, params = {}) {
  if (!isAnalyticsEnabled || typeof window === "undefined" || !window.gtag) {
    return;
  }
  window.gtag("event", name, params);
}
